import { render, staticRenderFns } from "./DeclaredTable.vue?vue&type=template&id=0d5cb735&"
import script from "./DeclaredTable.vue?vue&type=script&lang=js&"
export * from "./DeclaredTable.vue?vue&type=script&lang=js&"
import style0 from "./DeclaredTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports